import React, {ReactElement, useState} from 'react'
import {ChatMessage} from 'yougile-model'
import {
  MessageForwardingContext,
  MessageForwardingStore
} from '../message-forwarding-store'
import {MessageForwardingPopupBase} from './message-forwarding-popup-base'

interface Props {
  message: ChatMessage
  onSelect: (message: ChatMessage) => void
}

export const MessageForwardingPopup = ({
  message,
  onSelect
}: Props): ReactElement => {
  const [messageForwardingStore] = useState(
    () => new MessageForwardingStore(message)
  )
  return (
    <MessageForwardingContext.Provider value={messageForwardingStore}>
      <MessageForwardingPopupBase onSelect={onSelect} />
    </MessageForwardingContext.Provider>
  )
}
